import { useQuery } from '@tanstack/react-query'
import { api } from '@api'

export interface NearbyContact {
  id: string
  accountId: string | null
  fullName: string
  avatarUrl: string | null
  scope: string | null
  latitude: number | null
  longitude: number | null
  residence: string | null
  city: string | null
  country: string | null
  lastLocationAt: string | null
  distance: number | null
  sameCity: boolean
  sameCountry: boolean
  professions: string[]
}

export interface MyLocation {
  latitude: number | null
  longitude: number | null
  city: string | null
  country: string | null
  residence: string | null
  lastUpdated: string | null
}

interface NearbyContactsResponse {
  myLocation: MyLocation | null
  contacts: NearbyContact[]
}

interface NearbyParams {
  radius?: number
  mode?: 'city' | 'country' | 'distance'
  scope?: 'PRIVATE' | 'PROFESSIONAL'
}

const fetchNearbyContacts = async (params: NearbyParams): Promise<NearbyContactsResponse> => {
  const queryParams = new URLSearchParams()
  if (params.radius) queryParams.append('radius', params.radius.toString())
  if (params.mode) queryParams.append('mode', params.mode)
  if (params.scope) queryParams.append('scope', params.scope)
  const { data } = await api.get<NearbyContactsResponse>(`/ft_nearby-contacts?${queryParams}`)
  return data
}

export const useGetNearbyContacts = (params: NearbyParams = {}) => {
  return useQuery<NearbyContactsResponse>({
    queryKey: ['ft-nearby-contacts', params],
    queryFn: () => fetchNearbyContacts(params),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  })
}
